import React from 'react'

import styled from 'styled-components'

import PlayBtnSVG from 'assets/icons/play-btn.svg'

import { TestIDs } from '../../test/utils/testIds'

const PlayImage = styled.img`
  cursor: pointer;
  transition: opacity 300ms;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.7;
  }
`

interface Props {
  handleClick?: () => void
  className?: string
}

const PlayButton: React.SFC<Props> = ({ handleClick, className }) => (
  <PlayImage
    className={className}
    src={PlayBtnSVG}
    alt="Play Button"
    onClick={handleClick}
    role="button"
    tabIndex={0}
    data-testid={TestIDs.PLAY_BUTTON}
  />
)

export default PlayButton
